// DO NOT EDIT — generated from platform.config.json by `pnpm platform:generate`.
// Edit platform.config.json and re-run the generator instead (packages/frontend-shared/src/generated/client-games.ts).

/** Games this client deployed (Layer A), baked at build time. */
export const CLIENT_GAMES: Record<string, boolean> = {
  pickem: true,
  squares: true,
  dailyReveal: true,
  survivor: true,
  bingo: true,
  lobby: true,
};
